import { APP_CONFIGS } from './../_constants/config.constants';
import axios from 'axios';
import { msalInstance } from '..';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

axios.defaults.baseURL = APP_CONFIGS.API_BASE;

axios.interceptors.request.use(async (request) => {

  const _config = { scopes: APP_CONFIGS.API_SCOPE }
  const token = await msalInstance.acquireTokenSilent(_config)
    .catch(error => {
      if (error instanceof InteractionRequiredAuthError) {
        return msalInstance.acquireTokenRedirect(_config)
      }
    })
  // @ts-ignore
  request.headers.Authorization = `Bearer ${token.accessToken}`;
  request.headers['Ocp-Apim-Subscription-Key'] = APP_CONFIGS.APIM_SUBSCRIPTION_KEY;
  // request.headers['Access-Control-Allow-Origin'] = "https://localhost:44301";
  request.headers['Content-Type'] = 'application/json';
  return request;
}, (error) => {
  console.log('Request Error', error)
})

export * from './authorization.service'
export * from './user.service'
export * from './factory.service'
export * from './study-browser.service'
export * from './report.service'
export * from './pre-study.service'
export * from './shift.service'
export * from './operationMaster.service'
export * from './operatorMaster.service'
export * from './ie-distribution.service'

